'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.State = undefined;

var _UserBox = require('@/components/UserBox');

var _UserBox2 = _interopRequireDefault(_UserBox);

var _GlobalApi = require('@/libs/GlobalApi');

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _SidebarState = require('./SidebarState');

var _SidebarState2 = _interopRequireDefault(_SidebarState);

var _BufferSettings = require('./BufferSettings');

var _BufferSettings2 = _interopRequireDefault(_BufferSettings);

var _ChannelInfo = require('./ChannelInfo');

var _ChannelInfo2 = _interopRequireDefault(_ChannelInfo);

var _ChannelBanlist = require('./ChannelBanlist');

var _ChannelBanlist2 = _interopRequireDefault(_ChannelBanlist);

var _Nicklist = require('./Nicklist');

var _Nicklist2 = _interopRequireDefault(_Nicklist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.State = _SidebarState2.default;
exports.default = {
    components: {
        BufferSettings: _BufferSettings2.default,
        ChannelInfo: _ChannelInfo2.default,
        ChannelBanlist: _ChannelBanlist2.default,
        Nicklist: _Nicklist2.default,
        UserBox: _UserBox2.default
    },
    props: ['network', 'buffer', 'sidebarState'],
    data: function data() {
        return {
            pluginUiElements: _GlobalApi2.default.singleton().sideBarPlugins
        };
    },
    computed: {
        settingShowJoinParts: {
            get: function getSettingShowJoinParts() {
                return this.buffer.setting('show_joinparts');
            },
            set: function setSettingShowJoinParts(newVal) {
                return this.buffer.setting('show_joinparts', newVal);
            }
        },
        settingShowTopics: {
            get: function getSettingShowTopics() {
                return this.buffer.setting('show_topics');
            },
            set: function setSettingShowTopics(newVal) {
                return this.buffer.setting('show_topics', newVal);
            }
        },
        settingShowNickChanges: {
            get: function getSettingShowNickChanges() {
                return this.buffer.setting('show_nick_changes');
            },
            set: function setSettingShowNickChanges(newVal) {
                return this.buffer.setting('show_nick_changes', newVal);
            }
        },
        settingShowModeChanges: {
            get: function getSettingShowModeChanges() {
                return this.buffer.setting('show_mode_changes');
            },
            set: function setSettingShowModeChanges(newVal) {
                return this.buffer.setting('show_mode_changes', newVal);
            }
        },
        settingColouredNicklist: {
            get: function getSettingShowJoinParts() {
                return this.buffer.setting('coloured_nicklist');
            },
            set: function setSettingShowJoinParts(newVal) {
                return this.buffer.setting('coloured_nicklist', newVal);
            }
        },
        settingExtraFormatting: {
            get: function settingExtraFormatting() {
                return this.buffer.setting('extra_formatting');
            },
            set: function settingExtraFormatting(newVal) {
                return this.buffer.setting('extra_formatting', newVal);
            }
        },
        bufferType: function bufferType() {
            var type = '';

            if (!this.buffer) {
                type = 'none';
            } else if (this.buffer.isServer()) {
                type = 'server';
            } else if (this.buffer.isChannel()) {
                type = 'channel';
            } else if (this.buffer.isQuery()) {
                type = 'query';
            }

            return type;
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Sidebar"]
window._kiwi_exports.components.Sidebar = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sidebar.vue
// module id = f96R
// module chunks = 1